export * from "./WinMessage.tsx";
export { default } from "./WinMessage.tsx";
